export const unwrap = (r) => {
  const inner = r?.data ?? r;
  return inner?.data ?? inner;
};

export const fullName = (e) => {
  if (!e) return "—";
  const n = `${e.first_name || ""} ${e.last_name || ""}`.trim();
  return n || "(sin nombre)";
};

export const formatBytes = (bytes) => {
  if (!bytes && bytes !== 0) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
};

export const formatRelativeTime = (iso) => {
  if (!iso) return "—";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  const diff = (date.getTime() - Date.now()) / 1000;
  const abs = Math.abs(diff);
  const rtf = new Intl.RelativeTimeFormat("es", { numeric: "auto" });
  if (abs < 60) return rtf.format(Math.round(diff), "second");
  if (abs < 3600) return rtf.format(Math.round(diff / 60), "minute");
  if (abs < 86400) return rtf.format(Math.round(diff / 3600), "hour");
  if (abs < 86400 * 7) return rtf.format(Math.round(diff / 86400), "day");
  return date.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const extOf = (filename) => {
  if (!filename) return "";
  const idx = filename.lastIndexOf(".");
  return idx >= 0 ? filename.slice(idx + 1).toUpperCase() : "";
};

export const categoryDisplayName = (category) => {
  if (!category) return "—";
  if (category.parent_name) return `${category.parent_name} › ${category.name}`;
  return category.name;
};

// Caducidad — umbral en días para considerar un doc "próximo a vencer".
export const EXPIRY_NEAR_DAYS = 30;

const parseExpiry = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const isExpired = (iso) => {
  const d = parseExpiry(iso);
  if (!d) return false;
  return d.getTime() < Date.now();
};

export const isExpiringSoon = (iso, days = EXPIRY_NEAR_DAYS) => {
  const d = parseExpiry(iso);
  if (!d) return false;
  const ms = d.getTime() - Date.now();
  return ms >= 0 && ms <= days * 86400 * 1000;
};

/**
 * @returns {"none" | "expired" | "soon" | "ok"}
 */
export const getExpiryStatus = (iso, days = EXPIRY_NEAR_DAYS) => {
  if (!iso) return "none";
  if (isExpired(iso)) return "expired";
  if (isExpiringSoon(iso, days)) return "soon";
  return "ok";
};
